import React from 'react'
import { string, func } from 'prop-types'
import styles from './Messages.styl'

export default class Success extends React.Component {
	static propTypes = {
		label: string,
		cancelAction: func,
		confirmationAction: func
	}
	componentDidMount() {
		document.body.style.overflow = 'hidden'
	}
	componentWillUnmount() {
		document.body.style.overflow = 'inherit'
	}
	render() {
		const { label, cancelAction, confirmationAction } = this.props
		return (
			<section className={ styles.message_popup }>
				<div className={ styles.message_success }>
					<div className={ styles.message_container }>
						<h3>{ label }</h3>
					</div>
					<div>
						<button onClick={ confirmationAction }>Confirmar</button>
						<button onClick={ cancelAction }>Cancelar</button>
					</div>
				</div>
			</section>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/Messages/Confirmation.js